import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Heart } from "lucide-react";

const diffParts = (end) => {
  const now = new Date();
  if (end <= now) return null;
  let months = (end.getFullYear() - now.getFullYear()) * 12 + (end.getMonth() - now.getMonth());
  const shifted = (m) => { const d = new Date(now); d.setMonth(d.getMonth() + m); return d; };
  if (shifted(months) > end) months -= 1;
  let ms = end - shifted(months);
  const days = Math.floor(ms / 864e5); ms -= days * 864e5;
  const hours = Math.floor(ms / 36e5); ms -= hours * 36e5;
  const mins = Math.floor(ms / 6e4); ms -= mins * 6e4;
  return [[months, "Bulan"], [days, "Hari"], [hours, "Jam"], [mins, "Minit"], [Math.floor(ms / 1000), "Saat"]];
};

export const FarewellCountdown = ({ sessionEnd }) => {
  const end = new Date(sessionEnd);
  const [parts, setParts] = useState(() => diffParts(end));
  useEffect(() => {
    const t = setInterval(() => setParts(diffParts(new Date(sessionEnd))), 1000);
    return () => clearInterval(t);
  }, [sessionEnd]);
  if (!parts) return null;
  const endLabel = end.toLocaleDateString("ms-MY", { day: "numeric", month: "long", year: "numeric", timeZone: "Asia/Kuala_Lumpur" });

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="mt-4 rounded-2xl bg-gradient-to-br from-purple-50 via-pink-50 to-violet-100 border border-purple-200 p-3 text-center"
      data-testid="farewell-countdown"
      onClick={(e) => e.stopPropagation()}
    >
      <p className="flex items-center justify-center gap-1.5 font-black text-purple-700">
        <motion.span animate={{ scale: [1, 1.25, 1] }} transition={{ duration: 1.2, repeat: Infinity }}>
          <Heart className="w-4 h-4 text-purple-500" fill="currentColor" />
        </motion.span>
        Masa Bersama Destiny Junior
      </p>
      <p className="text-xs text-gray-500 mt-1">Masa bersama kami masih berbaki</p>
      <div className="grid grid-cols-5 gap-1 mt-2" data-testid="farewell-countdown-timer">
        {parts.map(([v, label]) => (
          <div key={label} className="rounded-lg bg-white/80 shadow-sm py-1">
            <motion.p key={v} initial={{ y: -6, opacity: 0 }} animate={{ y: 0, opacity: 1 }} className="text-base font-black text-purple-700 leading-none tabular-nums">
              {v}
            </motion.p>
            <p className="text-[10px] font-bold text-purple-400">{label}</p>
          </div>
        ))}
      </div>
      <p className="text-xs text-gray-600 mt-3 leading-relaxed">
        Terima kasih kerana menjadi sebahagian daripada keluarga Destiny Junior. Semoga setiap kenangan dan pengalaman bersama kami menjadi memori indah buat si kecil.
        <Heart className="w-3 h-3 inline ml-1 -mt-0.5 text-purple-500" fill="currentColor" />
      </p>
      <p className="text-[11px] text-gray-400 mt-2" data-testid="farewell-session-end">
        Sesi anak anda akan berakhir pada {endLabel}.
      </p>
    </motion.div>
  );
};
